// Shared error-state display for all Activity page tabs.
// Each tab makes an independent query; this component provides per-tab feedback and a
// retry callback so a failure in one tab does not block the others. (ref: DL-008)
import { BsExclamationTriangle } from 'react-icons/bs';

interface ErrorTabStateProps {
  message?: string;
  onRetry: () => void;
}

export function ErrorTabState({
  message = 'Something went wrong',
  onRetry,
}: ErrorTabStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <BsExclamationTriangle className="text-4xl text-danger mb-4" />
      <p className="text-base font-semibold text-neutral-700 dark:text-neutral-300">
        {message}
      </p>
      <button
        onClick={onRetry}
        className="mt-4 px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-lg hover:bg-primary-700 transition-colors"
      >
        Try again
      </button>
    </div>
  );
}
